/*
 *
 * File JS componente crop animation *
 */
import ScrollMagic from "scrollmagic";
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./crop-animation.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const cropAnimation = () => {
    // seleziono tutti gli items con la classe .cop-animation
    let cropAnimationItems = document.querySelectorAll(".crop-animation");
    if (!cropAnimationItems) return;
    let windowWidth = window.innerWidth;

    if (windowWidth > 1320) {
        const startAnimation = () => {
            let widthOfScreen = window.innerWidth;
            cropAnimationItems.forEach((item) => {
                //aggiungo uno style per width 100%

                if (widthOfScreen < 768) {
                    item.style.width = "calc(100% - 30px)";
                    item.style.maxWidth = "inherit";
                } else {
                    item.style.width = "100%";
                    item.style.maxWidth = "inherit";
                    var controllerCropAnimation = new ScrollMagic.Controller();

                    var sceneCropAnimation = new ScrollMagic.Scene({
                        triggerHook: "onEnter",
                        triggerElement: item,
                        duration: item.offsetHeight,
                        offset: -10,
                    })
                        .on("progress", function (evt) {
                            //prendo width della viewport
                            let width = window.innerWidth;
                            let height = window.innerHeight;
                            //definisco il wrapper con max width
                            let wrapper = 1290;
                            let cropVertical = 0;
                            let cropHorizontal = 0;

                            let offsetVertical = width - wrapper;
                            let offsetHorizontal = height;
                            if (offsetVertical > 0) {
                                if (evt.progress < 1) {
                                    cropVertical =
                                        ((width - wrapper) / 2) *
                                            (1 - evt.progress) +
                                        "px";
                                    cropHorizontal =
                                        (height / 8) * (1 - evt.progress) +
                                        "px";
                                    item.style.clipPath =
                                        "inset(" +
                                        cropHorizontal +
                                        " " +
                                        cropVertical +
                                        " " +
                                        cropHorizontal +
                                        " " +
                                        cropVertical +
                                        ")";
                                }
                            }
                        })
                        .addTo(controllerCropAnimation);
                }
            });
        };

        startAnimation();

        window.addEventListener("resize", startAnimation);
    } else {
        return;
    }
};

export default cropAnimation;

//--------------------------------------------------------------------//
